/**
 * Builds the nested Record workspace URL under a ticket's Records tab.
 */
export function getRecordWorkspacePath(input: {
	orgId: string;
	ticketId: string;
	recordId: string;
	tab?: string;
}): string {
	const tab = input.tab ?? "form";
	return `/web/${input.orgId}/tickets/${input.ticketId}/workspace/records/${input.recordId}/workspace/${tab}`;
}

/**
 * Builds the Record detail drawer URL for a ticket-scoped record instance.
 */
export function getRecordDrawerDetailsPath(input: {
	orgId: string;
	ticketId: string;
	recordId: string;
	tab?: string;
}): string {
	const tab = input.tab ?? "details";
	return `/web/${input.orgId}/tickets/${input.ticketId}/workspace/records/${input.recordId}/${tab}`;
}
